export function setTestId(id?: string) {
	return import.meta.env.REACT_APP_ENVIRONMENT === 'test' ? id : null;
}
